export default __webpack_public_path__ + "static/media/download.60f7268a.wav";